<template>
  <div class="container">
    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <div class="ml-3">
          <h2 class="my-3">Add Playlist</h2>
        </div>
      </div>

      <div class="card-body">

        <div v-if="!loading && success !== ''" class="alert text-center alert-success">{{ success }}</div>

        <div v-if="!loading" class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="name">Name</label>
              <input v-model="name" class="form-control" type="text" id="name" name="name" placeholder="Type a name">
            </div>
          </div>
        </div>

        <div v-if="!loading" class="row">
          <div class="col-md-12">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" id="draft" type="checkbox" v-model="isPublished">
              <label class="custom-control-label" for="draft">Check if published</label>
            </div>
          </div>
        </div>

        <div v-if="!loading && courses.length" style="margin-top: 2rem;">
          <div class="row justify-content-center">
            <div class="col-md-12 text-center">
              <h3>Available Courses</h3>
            </div>
            <div class="col-md-12 text-center">
              <p class="text-info">Click on course to add it</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4" v-for="(array, index) in chunked" :key="index">
              <div class="border shadow-lg bg-light">
                <div class="list-group">
                  <div
                      class="list-group-item"
                      :class="{'bg-green-custom': course.selected}"
                      style="cursor: pointer;"
                      v-for="course in array"
                      :key="course.id"
                      @click.prevent="addCourse(course)"
                  >
                    {{ course.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="text-center">
          <img src="@/assets/spinner.gif" alt="...">
        </div>

      </div>
      <div v-if="!loading" class="card-footer">
        <button :disabled="selectedCourses.length === 0 || name === ''" @click.prevent="save"
                class="btn btn-primary"
                type="submit">Save
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import authHeader from "@/services/auth-header";

export default {
  data() {
    return {
      firstTime: true,
      isPublished: false,
      chunked: [],
      name: '',
      courses: [],
      selectedCourses: [],
      loading: false,
      success: '',
    }
  },
  async mounted() {
    let email = this.$store.getters['auth/email'];
    await axios.get(`/api/v2/student-courses/${email}`, {headers: authHeader()})
        .then((response) => {
          this.courses = response.data;
        })
  },
  methods: {
    addCourse(course) {
      if (this.selectedCourses.indexOf(course) === -1) {
        this.courses[this.courses.indexOf(course)].selected = true
        this.selectedCourses.push(this.courses[this.courses.indexOf(course)])
      } else {
        this.courses[this.courses.indexOf(course)].selected = false
        this.selectedCourses.splice(this.selectedCourses.indexOf(course), 1);
      }
    },
    async save() {
      let email = this.$store.getters['auth/email'];
      this.loading = true;
      const data = {
        'isPublished': this.isPublished,
        'name': this.name,
        'courses': this.selectedCourses,
      }
      await axios.post(`/api/v2/playlist/${email}`, data, {headers: authHeader()})
          .then((response) => {
            if (response.data === 'success') {
              this.success = 'Playlist added successfully';
              this.$store.dispatch('auth/getUserData');
            }
          })
      this.name = ''
      this.courses.map(course => {
        course.selected = false;
      })
      setTimeout(() => this.loading = false, 2000);
    }
  },
  watch: {
    courses: function () {
      const n = 3
      const result = [[], [], []]

      const itemPerLine = Math.ceil(this.courses.length / 3)

      for (let line = 0; line < n; line++) {
        for (let i = 0; i < itemPerLine; i++) {
          const value = this.courses[i + line * itemPerLine]
          if (!value) continue
          result[line].push(value)
        }
      }

      this.chunked = result;
    }
  }
}
</script>

<style>
.bg-green-custom {
  background: darkseagreen;
}
</style>
